module.exports = __webpack_public_path__ + "img/fadcom.d4f16997.png";